export const multiStepConstants = {
    STEP_MIN: 0,
    STEP_FRONT: 1,
    STEP_INSIDE: 2,
    STEP_OPTIONS: 3,
    STEP_DELIVERY: 4,
    STEP_DEALS: 5,
    STEP_REVIEW: 6,
    STEP_MAX: 100,
};